<template>
  <section class="h-full w-full p-4">
    <base-card class="h-full flex flex-col justify-center items-center">
      <h2 class="text-2xl font-bold">Page not found!</h2>
      <p>
        This page could not be found - go to home page
        <router-link to="/"
          ><span class="underline cursor-pointer text-blue-700"
            >Home</span
          ></router-link
        >
      </p>
    </base-card>
  </section>
</template>
